module.exports = __webpack_public_path__ + "img/long-arrow.a7bb5b93.png";